import React, { useEffect, useState, useCallback, useMemo, useRef } from "react"
import { AgGridReact } from "ag-grid-react"
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-material.css';
import Modal from "react-modal";
import ModalContent from '../../common/Modal/ModalContent';
import close_modal from '../../assets/ic_close_wh.svg'
import ic_filter from '../../assets/ic_filter.svg'
import { Button } from "../../common/Button/Button";
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";
import downloadIcon from '../../assets/downloadIcon.png'
import { Info } from "react-feather";

const MergedSourceMediumTable = (props) => {

    const [MergedSourceMediumModal, setMergedSourceMediumModal] = useState(false)

    const gridRef = useRef()
    const containerStyle = useMemo(() => ({ width: "100%", height: "100%" }), []);
    const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);

    // const rowData = props.data

    const data = props.firstTimeData
  const data2 = props.engagedData

  const [rowData, setRowData] = useState([]);
  const [sourseNames, setSourseNames] = useState([]);
  const [mediumNames, setMediumNames] = useState([])
  const [MergedData, setMergedData] = useState([]);

  useEffect(() => {
    const mergedData = [];

    // Iterate over the first dataset
    data.forEach(item1 => {
      const mergedItem = {
        sourse_name: item1.sourse_name,
        medium_name: item1.medium_name,
        first_time_data: item1.resourse_count,
        engaged_count: 0,
      };

      // Find a matching item in the second dataset
      const matchingItem = data2.find(item2 => (
        item2.sourse_name === item1.sourse_name &&
        item2.medium_name === item1.medium_name
      ));

      // If a matching item is found, update the engaged_count
      if (matchingItem) {
        mergedItem.engaged_count = matchingItem.resourse_count;
      }

      mergedData.push(mergedItem);
    });

    // Iterate over the second dataset to find any missing entries
    data2.forEach(item2 => {
      const matchingItem = mergedData.find(item => (
        item.sourse_name === item2.sourse_name &&
        item.medium_name === item2.medium_name
      ));

      // If a matching item is not found, add it to the merged dataset with first_time_data as 0
      if (!matchingItem) {
        mergedData.push({
            sourse_name: item2.sourse_name,
            medium_name: item2.medium_name,
          first_time_data: 0,
          engaged_count: item2.resourse_count,
        });
      }
    });

    console.log("MergData", mergedData);

    const partnerNamesSet = new Set(mergedData.map(data => data.sourse_name));
    const partnerNames = Array.from(partnerNamesSet);
    const ResourseNamesSet = new Set(mergedData.map(data => data.medium_name));
    const resourseNames = Array.from(ResourseNamesSet);
    setSourseNames(partnerNames)
    setMediumNames(resourseNames)
    setRowData(mergedData)
    setMergedData(mergedData)
  }, [data, data2])

  useEffect(() => {
    if (props.selectedOptionsMergedSourceMedium.length > 0) {
      const filteredData = MergedData.filter(obj => props.selectedOptionsMergedSourceMedium.some(item => item.value === obj.sourse_name));
      console.log("Filt Data", filteredData);
      let arr1 = []
      filteredData.map((ele) => {
        if (ele.medium_name != "" && ele.medium_name != null) {
          arr1.push(ele.medium_name)
        }
      });
      setMediumNames(arr1);
    }else {
        const mediumNames = MergedData.reduce((uniqueNames, row) => {
            if (row.medium_name && (row.medium_name != null && row.medium_name != "") && !uniqueNames.includes(row.medium_name)) {
              uniqueNames.push(row.medium_name);
            }
            return uniqueNames;
          }, []);
          setMediumNames(mediumNames)
    }
  }, [props.selectedOptionsMergedSourceMedium, MergedData])

  useEffect(() => {
    if (props.selectedOptionsMergedSourceMediumEu.length > 0) {
      const filteredData = MergedData.filter(obj => props.selectedOptionsMergedSourceMediumEu.some(item => item.value === obj.medium_name));
      console.log("Filt Data", filteredData);
      let arr1 = []
      filteredData.map((ele) => {
        if (ele.sourse_name != "" && ele.sourse_name != null) {
          arr1.push(ele.sourse_name)
        }
      });
      setSourseNames(arr1);
    } else {
        const sourceNames = MergedData.reduce((uniqueNames, row) => {
            if (row.sourse_name && (row.sourse_name != null && row.sourse_name != "") && !uniqueNames.includes(row.sourse_name)) {
              uniqueNames.push(row.sourse_name);
            }
            return uniqueNames;
          }, []);
          setSourseNames(sourceNames)
    }
  }, [props.selectedOptionsMergedSourceMediumEu, MergedData])

    const footerRow = {
        medium_name: "Total",
        first_time_data: "Total" + " : " + " " + rowData.reduce((total, row) => total + row.first_time_data, 0),
    engaged_count: "Total" + " : " + " " + rowData.reduce((total, row) => total + row.engaged_count, 0),
    };

    const openMergedSourceMediumModalisTrue = () => {
        setMergedSourceMediumModal(true)
      }
    
      const openMergedSourceMediumModalisFalse = () => {
        setMergedSourceMediumModal(false)
      }
    
      const handleClearClick = () => {
        props.setSelectedOptionsMergedSourceMedium([])
        props.setSelectedOptionsMergedSourceMediumEu([])
      }

    const [columnDefs, setColumnDefs] = useState([
        {
            field: "sourse_name",
            headerName: "Source",
            width: 380,
            headerComponentFramework: (params) => {
                return (
                    <div style={{ display: "flex",width: '100%', alignItems: "center" }}>
                        <div>{params.displayName}</div>
                    </div>
                );
            },
            cellStyle: { 'white-space': 'normal' },
            autoHeight: true,
        },
        {
            field: "medium_name",
            headerName: "Medium",
            width: 380,
            // flex:1,
            cellStyle: { 'white-space': 'normal' },
            autoHeight: true,
            headerComponentFramework: (params) => {
                return (
                    <div style={{ display: "flex",width: '100%', alignItems: "center" }}>
                        <div style={{ marginRight: "260px" }}>{params.displayName}</div>
                        <img
                        alt=""
                        src={ic_filter}
                        height={"25px"}
                        width={"25px"}
                        className="conv-mr10"
                        onClick={() => openMergedSourceMediumModalisTrue()}
                    />
                    </div>
                );
            },
            cellRenderer: (params) => {
                const resourseName = params.value || "Not Provided";
                if (resourseName === "Total") {
                  return <div style={{ textAlign: "right", display: 'none' }}>{resourseName}</div>;
                } else {
                  return resourseName;
                }
              },
        },
        {
            field: "first_time_data",
            headerName: "First Time Count",
            // width: 180,
            flex: 1,
            sortable: true,
            pinnedBottomRowCellRenderer: "agGroupCellRenderer",
            cellStyle: { textAlign: "right" },
            headerComponentFramework: (params) => {
              return (
                <div style={{ display: "flex", justifyContent: 'flex-end', width: '100%', alignItems: "center" }}>
                  <div>{params.displayName}</div>
                </div>
              );
            },      
          },
          {
            field: "engaged_count",
            headerName: "Engaged Count",
            // width: 180,
            flex: 1,
            sortable: true,
            pinnedBottomRowCellRenderer: "agGroupCellRenderer",
            cellStyle: { textAlign: "right" },
            headerComponentFramework: (params) => {
              return (
                <div style={{ display: "flex", justifyContent: 'flex-end', width: '100%', alignItems: "center" }}>
                  <div>{params.displayName}</div>
                </div>
              );
            },      
          },
    ]);

    const handleMergedSourceMediumSelect = (selected) => {
        props.setSelectedOptionsMergedSourceMedium(selected)
        console.log("select", props.selectedOptionsMergedSourceMedium)
      }
    
      const handleMergedSourceMediumSelectEu = (selected) => {
        props.setSelectedOptionsMergedSourceMediumEu(selected)
        console.log("select", props.selectedOptionsMergedSourceMediumEu)
      }

      const handleMergedSourceMediumFilterSearchClick = () => {
        if (props.selectedOptionsMergedSourceMedium.length > 0 && props.selectedOptionsMergedSourceMediumEu.length > 0) {
          const filteredPartnerData = MergedData.filter((partner) =>
            props.selectedOptionsMergedSourceMedium.some((option) => option.value === partner.sourse_name) &&
            props.selectedOptionsMergedSourceMediumEu.some((option) => option.value === partner.medium_name)
          );
          console.log(filteredPartnerData);
          setRowData(filteredPartnerData);
        }
        else if (props.selectedOptionsMergedSourceMedium.length > 0) {
          const filteredPartnerData = MergedData.filter((partner) =>
            props.selectedOptionsMergedSourceMedium.some((option) => option.value === partner.sourse_name)
          );
          console.log(filteredPartnerData);
          setRowData(filteredPartnerData);
        } else if (props.selectedOptionsMergedSourceMediumEu.length > 0) {
          const filteredPartnerData = MergedData.filter((partner) =>
            props.selectedOptionsMergedSourceMediumEu.some((option) => option.value === partner.medium_name)
          );
          console.log(filteredPartnerData);
          setRowData(filteredPartnerData);
        } else {
          setRowData(MergedData);
        }
        openMergedSourceMediumModalisFalse();
      }

    const gridOptions = useMemo(() => ({
        suppressScrollOnNewData: true,
    }), []);

    // const handleDownloadCSV = () => {
    //   const csvData = [];
    //   csvData.push('Source, Medium, First Time Count, Engaged Count'); // CSV header
  
    //   rowData.forEach(row => {
    //     csvData.push(`${row.sourse_name}, ${row.medium_name}, ${row.first_time_data}, ${row.engaged_count}`);
    //   });
  
    //   const csvBlob = new Blob([csvData.join('\n')], { type: 'text/csv' });
    //   const csvUrl = window.URL.createObjectURL(csvBlob);
  
    //   const downloadLink = document.createElement('a');
    //   downloadLink.href = csvUrl;
    //   downloadLink.download = 'source_medium_data.csv';
    //   downloadLink.style.display = 'none';
    //   document.body.appendChild(downloadLink);
    //   downloadLink.click();
  
    //   window.URL.revokeObjectURL(csvUrl);
    //   document.body.removeChild(downloadLink);
    // };

    const handleDownloadCSV = () => {
      const csvData = [];
      csvData.push('Source, Medium, First Time Count, Engaged Count'); // CSV header
  
    
      rowData.forEach(row => {
        // Check if 'sourse_name' and 'medium_name' are not null before processing
        const sourceName = (row.sourse_name !== null && row.sourse_name !== '') ? row.sourse_name.replace(/\n/g, ' ') : (row.sourse_name === null ? 'null' : '');
      // const mediumName = row.medium_name ? row.medium_name.replace(/\n/g, ' ') : '';
      const mediumName = (row.medium_name !== null && row.medium_name !== '') ? row.medium_name.replace(/\n/g, ' ') : (row.medium_name === null ? 'null' : '');

    
        // Escape double quotes in 'sourceName' and 'mediumName' to avoid CSV issues
        const escapedSourceName = sourceName.replace(/"/g, '""');
        const escapedMediumName = mediumName.replace(/"/g, '""');
    
        // Create the CSV row
        csvData.push(`${escapedSourceName}, ${escapedMediumName}, ${row.first_time_data}, ${row.engaged_count}`);
      });
  
    
      const csvBlob = new Blob([csvData.join('\n')], { type: 'text/csv' });
      const csvUrl = window.URL.createObjectURL(csvBlob);
  
    
      const downloadLink = document.createElement('a');
      downloadLink.href = csvUrl;
      downloadLink.download = 'source_medium_data.csv';
      downloadLink.style.display = 'none';
      document.body.appendChild(downloadLink);
      downloadLink.click();
  
    
      window.URL.revokeObjectURL(csvUrl);
      document.body.removeChild(downloadLink);
    };
  
  

    return (
      <div>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        // justifyContent: 'center',
        margin: 10
      }}>
        <h3 className="spled-colored-label" style={{
          fontSize: "20px",
          textAlign: 'center',
          marginRight: 10
        }}>3. First Time / Engaged Users based on Source / Medium</h3>
        <span style={{ cursor: "pointer" }} title="Display of First time users and engaged users based on Source / Medium">
          <Info style={{ width: "15px", marginRight: "10px", marginBottom:"5px" }} />
        </span>
        {
          rowData.length > 0 && (
            // <Button className="esp-inline-button"
            //   onClick={handleDownloadCSV}
            // >Download CSV</Button>
            <img src={downloadIcon} title="Download CSV" alt="" onClick={handleDownloadCSV} style={{
              cursor: "pointer"
            }} />
          )
        }
      </div>

        <div style={{
            height: "50vh",
        }}>
            <div style={{ height: "100%", boxSizing: "border-box" }}>
                <div style={gridStyle} className="ag-theme-material">
                    <AgGridReact ref={gridRef}
                        rowData={rowData}
                        columnDefs={columnDefs}
                        pinnedBottomRowData={[footerRow]}
                        gridOptions={gridOptions}
                        overlayNoRowsTemplate={
                            '<span class="ag-overlay-loading-center">loading...</span>'
                        }
                        rowClassRules={{
                            'total-row': 'data.medium_name === "Total"'
                        }}
                    >
                    </AgGridReact>
                </div>
            </div>

            <Modal isOpen={MergedSourceMediumModal}>
        <ModalContent className="EngagedDashboard-filter-modal">
          <div className="modal-header">
            <span className="modal-title">Filter</span>
            <img
              alt="close"
              id="Close"
              src={close_modal}
              className="close modal-close"
              onClick={openMergedSourceMediumModalisFalse}
            />
          </div>

          <div className="modal-body">
            <br />
            <div className="row">
              <div className="col-6 spled-container">
                <div className="width-100">
                  <ReactMultiSelectCheckboxes
                    options={sourseNames.map((partner) => ({
                      label: partner,
                      value: partner,
                    }))}
                    // placeholder="Select partners"
                    placeholderButtonLabel="Select Source"
                    value={props.selectedOptionsMergedSourceMedium}
                    onChange={handleMergedSourceMediumSelect}
                  />
                </div>
              </div>
              <div className="col-6 spled-container">
                <div className="width-100">
                  <ReactMultiSelectCheckboxes
                    options={mediumNames.map((program) => ({
                      label: program,
                      value: program,
                    }))}
                    // placeholder="Select partners"
                    placeholderButtonLabel="Select Medium"
                    value={props.selectedOptionsMergedSourceMediumEu}
                    onChange={handleMergedSourceMediumSelectEu}
                  />
                </div>
              </div>
            </div>
            <br />
            <div className='row d-flex justify-content-center align-items-center'>
              <div className="offset-1 col-5">
                <Button className="esp-inline-button" onClick={handleMergedSourceMediumFilterSearchClick}>Search</Button>
              </div>
              <div className="col-5">
                <Button className="esp-inline-button" onClick={handleClearClick}>Clear</Button>
              </div>
              {/* <div className="col-4"></div> */}
            </div>

          </div>
        </ModalContent>
      </Modal>
        </div>
        </div>
    )
}

export default MergedSourceMediumTable
